import { t } from 'i18next';
import { StringOption } from '@/types/generic';
import { convertToDropdownOption } from '@/utils/object';

export const buildPositionOptions = (
  positions: Array<{ position: string; percentage: number }>,
): { positionOptions: StringOption[]; otherPositions: string[] } =>
  positions.reduce<{ positionOptions: StringOption[]; otherPositions: string[] }>(
    (acc, { position, percentage }) => {
      if (percentage < 1) {
        return { ...acc, otherPositions: [...acc.otherPositions, position] };
      }
      return {
        ...acc,
        positionOptions: [
          ...acc.positionOptions,
          convertToDropdownOption(
            `${t(`fields.event.attributes.playerPosition.${position}`, { ns: 'events' })} - ${percentage.toFixed(2)}%`,
            position,
          ),
        ],
      };
    },
    { positionOptions: [], otherPositions: [] },
  );
